import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from 'angularfire2/database';
import { AbsAuthService, AntEnvService, DataService, HelperService } from '../../_services';
import { DataServiceProvider } from 'src/app/_providers';
import * as moment from 'moment';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  //changeDetection: ChangeDetectionStrategy.Default
})
export class UsersComponent implements OnInit {
  lstLoginTime: any[] = [];

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    private firebaseAuth: AngularFireAuth,
    private http: HttpClient,
    private svcAuth: AbsAuthService,
    private svcAntEnv: AntEnvService,
    private svcData: DataService,
    private svcHelper: HelperService,
  ) {
    this.svcAuth = DataServiceProvider.useFactory(this.firebaseAuth, this.http, this.svcAntEnv);
  }
  
  pageData = {
    account: {
      fullName: '', email: '', password: '', confirmPassword: '', imageUrl: '', role: 'ADMIN'
      //fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    actionMode: 'NEW',
    userList: [],
  };
  tAccount:any; oAcc:any;
  roles = [
    {title: 'Admin', value: 'ADMIN'},
    {title: 'Normal', value: 'NORMAL'},
  ];
  roleSelected: any;
  isLoading: false;
  ngOnInit() {
    this.dataLoad();
  }

  ngAfterViewInit(){
    //console.log('this is ngAfterViewInit');
    this.svcData.usageAdd('{"userId":"'+JSON.parse(localStorage.getItem("currentUser")).userId+'","code":"USERMANAGEMENT-VIEW","actionCode":"USERMANAGEMENT-VIEW"}').subscribe();
  }

  dataLoad(){
    this.oAcc = this.svcAuth.getCurrentUser();
    if(!this.oAcc){
      this.router.navigate(['/login']);
      return;
    }
    this.loading(true);
    this.svcData.userList().subscribe(res=>{
      this.loading(false);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.userList = res.data;
      this.lastLoginTime();
    });
  }
  dataLoadFirebase(){
    this.loading(true);
    // this.db.list('accounts').snapshotChanges().subscribe(res=>{
    //   this.loading(false);
    //   this.pageData.userList = [];
    //   res.forEach(resDetail=>{
    //     var _record:any = resDetail.payload.val();
    //     _record.key = resDetail.key;
    //     this.pageData.userList.push(_record);
    //   });
    // });
  }
  onSubmit(){
    var _isEdit = this.pageData.actionMode == 'EDIT';
    if(this.pageData.account.fullName.length<1){
      this.showAlert('Full Name should not be empty!');
      return;
    }
    if(!_isEdit && this.pageData.account.email.length<1){
      this.showAlert('Email should not be empty!');
      return;
    }
    // if(this.pageData.account.title.length<1){
    //   this.showAlert('Title should not be empty!');
    //   return;
    // }
    if(!_isEdit && this.pageData.account.password.length<1){
      this.showAlert('Password should not be empty!');
      return;
    }
    if(!_isEdit && this.pageData.account.password.length<8){
      this.showAlert('Minimum password length is 8!');
      return;
    }
    if(!_isEdit && this.pageData.account.password != this.pageData.account.confirmPassword){
      this.showAlert('Password and Confirm Password mismatch!');
      return;
    }
    if(!this.roleSelected){
      this.showAlert('Please select the Role for the user!');
      return;
    }
    // if(this.pageData.account.contactNo.length<1){
    //   this.showAlert('Contact Number should not be empty!');
    //   return;
    // }
    this.loading(true);
    var _pwdHash = this.svcHelper.aesEncrypt(this.pageData.account.password);
    var _acc:any = {
      Client: { ClientId: '' },
      Email: this.pageData.account.email,
      FullName: this.pageData.account.fullName,
      Password: _pwdHash,
      Role: this.roleSelected.value
    };
    if(_isEdit){
      _acc.userId = this.tAccount.userId;
      this.svcData.userUpdateFullNameAndRole(_acc).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        if(this.amSA()){
          this.svcData.userConfigSet(this.tAccount.userId, 'alert.dailyCountEmail', this.tAccount.alertDailyCountEmail?'1':'0').subscribe(res=>{
            if(res.status != 'OK'){
              this.showAlert(res.message);
              return;
            }
          });
        }
        this.dataLoad();
        this.pageData.viewMode = 'LIST';
        this.showAlert('User information updated!');
      });
    }
    else{
      this.svcData.userAdd(_acc).subscribe(res=>{
        this.loading(false);
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.dataLoad();
        this.pageData.viewMode = 'LIST';
      });
    }
    // this.svcAuth.signUp(this.pageData.account.email, this.pageData.account.password).then( res=>{
    //   //console.log(res);
    //   this.db.list('/accounts').push({
    //     uid: res.user.uid,
    //     fullName: this.pageData.account.fullName, 
    //     email: this.pageData.account.email,
    //     title: this.pageData.account.title,
    //     contactNo: this.pageData.account.contactNo,
    //     role: this.pageData.account.role,
    //     imageUrl: this.pageData.account.imageUrl
    //   });
    //   this.loading(false);
    //   this.pageData.viewMode = 'LIST';
    // })
    // .catch(err=>{
    //   this.loading(false);
    //   this.showAlert(err);
    //   //this.changeDetector.detectChanges();
    // });
  }
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  roleSelect(arg){
    this.roleSelected = arg;
  }
  showAlert(msg){
    //alert(msg);
    M.toast({html: msg});
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
    this.pageData.actionMode = arg ? 'EDIT' : 'NEW';
    window.setTimeout(function(){
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
    }, 500);

    if(this.pageData.actionMode == 'EDIT'){
      this.tAccount = arg;
      this.pageData.account.fullName = arg.fullName;
      this.pageData.account.email = arg.email;
      this.roles.forEach(r=>{
        if(r.value == arg.role){
          this.roleSelected = r;
        }
      });
      if(this.amSA()){
        this.svcData.userConfigGet(this.tAccount.userId, 'alert.dailyCountEmail').subscribe(res=>{
          if(res.status != 'OK'){
            this.showAlert(res.message);
            return;
          }
          this.tAccount.alertDailyCountEmail = res.data == '1';
        });
      }
    }
  }
  userDelete(arg){
    if(!confirm(`Are you sure you want to delete the user "${arg.fullName}"?`)) return;

    this.svcData.userDelete(arg).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.dataLoad();
      this.showAlert('User successfully deleted!');
    });
  }
  userList(){
    this.pageData.viewMode = 'LIST';
  }
  amSA():boolean{
    return this.oAcc && this.oAcc.role == 'SA';
  }

  lastLoginTime(){
      this.pageData.userList.forEach((e,i) => {
          e.param1 = moment(e.lastLoginUtc).fromNow();
      });
  }

  parseDate(str: any) {
    var mdy = str.toString().split('/');
    return new Date(mdy[2], mdy[0] - 1, mdy[1]);
}

datediff(first, second) {        
    return Math.round((first - second) / (1000 * 60 * 60 * 24));
}
  
}
